import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header.component';
import { CommonModule } from '@angular/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    RouterModule
  ],
  exports: [
    HeaderComponent
  ]
})

export class HeaderModule { }
